// Uses the existing MongoDB/JSON catalogue merge and current-language selection.
const ERROR_ALIASES = { INVALID_TARGET_ROLE: 'ROLE_NOT_ALLOWED', UNAUTHORIZED: 'AUTHENTICATION_REQUIRED', INTERNAL_ERROR: 'TOKEN_INVALID' };
export const tokenText = infoSource => code => {
  const key = ERROR_ALIASES[code] || code;
  return (
  infoSource?.laguangeElakay?.('roleChangeRequest', infoSource.languageAPI)?.roleTokens?.[key] ||
  infoSource?.laguangeElakay?.('roleChangeRequest', [])?.roleTokens?.[key] || key
  );
};
